module.exports = __webpack_public_path__ + "img/stars.0431608.png";